export default "__VITE_ASSET__BRS37D3i__"